export default __webpack_public_path__ + "static/media/1879.008e5314.png";